export const maskingUtil = (maskFor, value) => {
  if (!value) return "";

  switch (maskFor) {
    case "email": {
      const atIndex = value.indexOf("@");
      if (atIndex === -1) return value; // invalid email

      const localPart = value.slice(0, atIndex);
      const domain = value.slice(atIndex);

      // keep first 3 chars, mask the rest until @
      const visiblePart = localPart.slice(0, 3);
      const maskedPart = "x".repeat(Math.max(localPart.length - 3, 0));

      return visiblePart + maskedPart + domain;
    }

    case "phone": {
      if (value.length <= 6) {
        return "x".repeat(value.length);
      }
      const maskedPart = "x".repeat(6);
      const visiblePart = value.slice(6);
      return maskedPart + visiblePart;
    }

    default:
      return value;
  }
};

export function generalMaskString(str) {
  if (str.length <= 4) {
    // If string is too short, just return as is
    return str;
  }
  const start = str.slice(0, 2);
  const end = str.slice(-2);
  const masked = "x".repeat(str.length - 4);
  return start + masked + end;
}
